import { createSlice } from "@reduxjs/toolkit";

/**
 * 파일명: navSlice.js
 * 작성자: 강연승
 * 작성일자: 26.02.25
 * 설명: 스크롤 정보
 */
const navSlice = createSlice({
  name: "nav",
  initialState: {
    link: "",
  },
  reducers: {
    setNav: (state, action) => {
      state.link = action.payload.link;
    },
  },
});

export default navSlice;

export const { setNav } = navSlice.actions;
